import * as tslib_1 from "tslib";
import { observable } from 'mobx';
var Note = /** @class */ (function () {
    function Note(dto) {
        Object.assign(this, dto);
    }
    tslib_1.__decorate([
        observable
    ], Note.prototype, "text", void 0);
    return Note;
}());
export { Note };



//////////////////
// WEBPACK FOOTER
// ./src/models/Note.ts
// module id = 190
// module chunks = 0